<template>

    <div    v-bind:id="'page-'+page.number"
            class="catalog-page fadeIn active animated"
            v-bind:class="{'page_right': is_first, 'page_left': is_last, 'zoomable': show_zoom_icon}"
            v-bind:data-position="position">
        <div v-bind:id="'img_container_'+page.number" class="polygon-container" @click.stop.prevent='pageClicked'>
            <img v-bind:src="page.image_large" class="page-image"  v-bind:data-i-id="page.number"/>
            <svg v-bind:width='svg_width' v-bind:height="svg_height" v-bind:viewBox="getViewBox()">
                <path 
                        v-for="(path, key) in page.polygons" 
                        @mousemove="mouseMove($event)"
                        @mouseover="mouseOver($event, path)"
                        @mouseleave="mouseLeave()"
                        @click.stop.prevent="pathClicked(path)"
                        v-bind:key="key" 
                        v-bind:fill="polygon_color"
                        v-bind:stroke="polygon_color"
                        v-bind:d="path.coordinates" 
                        stroke-width="1" 
                        fill-opacity="0.4" 
                        opacity="0" 
                        v-bind:data-function_type="path.function_type" />
            </svg>
<!--            <button v-if="show_zoom_icon" class='icon-wrapper bg zoom' @click.stop.prevent='$emit("zoom", page)'>
                <i class="icon-zoom-plus" ></i>
            </button>  -->
        </div>
    </div>

</template>

<script>
export default {
    name: 'CatalogPage',
    props: ["page", "is_first", "is_last", "position", "is_mobile", "catalog_size", "viewbox_size", "pages_shown", "show_zoom_icon"],
    data: function(){
        return {
            svg_width : "100%",
            svg_height : "100%",
            polygons: [],
            polygon_color: 'transparent'
        };
    },
    mounted: function(){
        this.getPolygons();
    },
    destroyed() {
        
    },
    methods:{
        pageClicked: function(e){
            if(this.show_zoom_icon){
                var xpos = e.offsetX * 100 / this.viewbox_size.width;
                var ypos = e.offsetY * 100 / this.viewbox_size.height;
                this.$emit("zoom", this.page, xpos, ypos);
            }
        },
        getPolygons: function(){
            this.polygons = this.page.polygons;
        },
        setViewboxSize: function(){
            this.viewbox_size.width = this.catalog_size.width / this.pages_shown;
            this.viewbox_size.height = this.catalog_size.height;
        },
        mouseOver: function(event, polygon_path){
            if(this.is_mobile){
                return false;
            }
            this.$emit("showtooltip", event, polygon_path, ()=>{ this.pathClicked(polygon_path, true) });
        },
        mouseMove: function(event){
            if(this.is_mobile){
                return false;
            }    
            this.$emit("updatetooltipposition",event);
        },
        mouseLeave: function(){
            if(this.is_mobile){
                return false;
            }    
            this.$emit("hidetooltip");
        },
        pathClicked: function(path, force_click){
            
            if(!this.is_mobile || force_click){
                switch(path.function_type){
                    case "open_url":
                        this.$emit("openurl", path.function_value);
                            break;
                    case "product":
                        this.$emit("openitem", path.function_value);
                            break;
                    case "go_to_page":
                        this.$emit("gotopage", path.function_value);
                            break;
                }
            }else{
                var self = this;
                this.$emit("showtooltip", null, path, function(){ self.pathClicked(path, true) });
            }
            
        },
        isPathEmpty: function(polygon_path){
            if( polygon_path.function_value == undefined || polygon_path.function_value == "" || 
                polygon_path.function_type == undefined || polygon_path.function_type == ""){
                return true;
            }else{
                return false;
            }
        },
        getViewBox: function(){
            var viewBoxWidth = 1080 / 2;
            return "0 0 "+viewBoxWidth+" 720";

        }
    },
    computed: {
    }
}
</script>
